import {axiosNpsWorkersInstance} from "../Utilities/axios";
import {useEmployeeContext} from "../context/PuzzelContext";
import {Respondent} from "../models/nps";
import phone from "phone";

export function useApi() {
    const {
        setShouldHavePGap,
        employeeState,
        puzzelState,
        delayNewCall,
        delayEndCall,
        delayEndChat
    } = useEmployeeContext();
    const {group, userId, email} = employeeState
    const {queueKey, object, formattedNumber, agentRating, sessionId} = puzzelState

    function upsertSession(): Promise<any> {
        let url = `puzzel/add/${sessionId}?userId=${userId}`
        //outcomment if we want to add delay to new call
        /*if (delayNewCall) {
            url += `&offset=${delayNewCall}`
        }*/
        return axiosNpsWorkersInstance.post(url);
    }

    function addNewChat(respondent: Respondent): Promise<any> {
        let url = `puzzel/chat/${sessionId}?queueKey=${queueKey}`
        if (delayEndChat) {
            url += `&offset=${delayEndChat}`
        }
        return axiosNpsWorkersInstance.post(url, respondent);
    }

    function convertObjectToRespondent(): Respondent | null {
        if (!object || !formattedNumber || !email || !group || !userId) return null;
        if (("caller" in object)) {
            return {
                respondent: {
                    phoneNumber: formattedNumber,
                },
                employee: {
                    email: email,
                    firstName: object.vars["system_last_user_firstname"],
                    lastName: object.vars["system_last_user_lastname"],
                    team: group,
                    externalId: userId
                },
                custom: {
                    sessionId: object.sessionId,
                    queue: object.queueKey,
                    queueDuration: object.vars["system_queue_time"],
                    callDuration: Math.round(object.vars['system_speaktime'] / 1000),
                    rawNumber: object.caller,
                    callProgress: object.vars["system_call_progress"],
                    callState: object.vars["current_state"],
                    agentEvent: object.vars['agentEvent.cause'],
                    crmdbLastcallStart: object.vars["crmdb_lastcall_start"],
                },
                agentRating: agentRating
            }
        } else {
            
            const phoneNumber = object.variables.find(v => v.name === "phoneNumber" || v.source === "CHATAPI")?.value;
            let customerNumber: string | null;

            if (!phone(phoneNumber, {country: 'DK'}).isValid) {
                if (!phone(phoneNumber.replace(/0{2}/, '+')).isValid) {
                    customerNumber = phoneNumber; // Call is not danish/ is hidden
                } else {
                    customerNumber = phone(phoneNumber.replace(/0{2}/, '+')).phoneNumber;
                }
            } else {
                customerNumber = phone(phoneNumber, {country: 'DK'}).phoneNumber;
            }

            return {
                respondent: {
                    phoneNumber: customerNumber ?? formattedNumber,
                },
                employee: {
                    email: email,
                    team: group,
                    externalId: userId
                },
                custom: {
                    sessionId: object.sessionId,
                    queue: object.queueKey,
                    chatState: object.status,
                },
                agentRating: agentRating
            };
        }
    }

    function newCall() {
        addSessionIfCaller();
    }

    function endCall() {
        addSessionIfCaller();
    }

    function addSessionIfCaller () {
        const isCaller = object && "caller" in object;
        if (isCaller) {
            upsertSession();
        }
    }

    function endChat() {
        const payload = convertObjectToRespondent()
        if (!payload) return;
        addNewChat(payload).then(r => {
            setShouldHavePGap(r.pgap);
        });
    }


    return {newCall, endCall, endChat};
}